import React from 'react';
import Box from '@mui/material/Box';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import PropsTypes from 'prop-types';
import { Delete } from '@mui/icons-material';

const AddressBookItem = ({ item, onDeleteAddressBook, labelDelete, index, form, jabatan = false, type }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                mb: 1,
                px: 2.5,
                py: 1.5
            }}
        >
            {!form &&
                <Box sx={{ mr: 3, width: '10px' }}>
                    <Typography variant='body2'>{index + 1}. </Typography>
                </Box>
            }
            {/* <Box sx={{ mr: 3 }}>
                <Person />
            </Box> */}
            {
                jabatan ? (
                    <Stack flex={1}>
                        {
                            item.title && item.title !== '' ? (
                                <>
                                    <Typography fontWeight={'bold'}>{item.title}</Typography>
                                    <Typography color={'GrayText'}>{item.nama}</Typography>
                                </>
                            ) : (
                                <Typography fontWeight={'bold'}>{item.nama}</Typography>
                            )
                        }
                    </Stack>
                ) : (
                    typeof (item) === 'object' ? (
                        <Box sx={{ flex: 1 }}>
                            <Typography fontWeight={'bold'}>{item.nama}</Typography>
                        </Box>
                    ) : (
                        <Box sx={{ flex: 1 }}>
                            <Typography fontWeight={'bold'}>{item}</Typography>
                        </Box>

                    )
                )
            }
            {
                onDeleteAddressBook && (
                    type != 'readOnly' && <Tooltip arrow title={labelDelete ? labelDelete : 'Hapus Lampiran'} placement='right'>
                        <IconButton
                            sx={{
                                padding: 1.5,
                                fontSize: 16,
                            }}
                            onClick={onDeleteAddressBook}
                        >
                            {labelDelete && <Delete sx={{ fontSize: 18 }} />}
                        </IconButton>
                    </Tooltip>
                )
            }
        </Box>
    );
};

export default AddressBookItem;
AddressBookItem.propTypes = {
    jabatan: PropsTypes.bool,
    form: PropsTypes.string,
    item: PropsTypes.any,
    onDeleteAddressBook: PropsTypes.func,
    labelDelete: PropsTypes.string,
    index: PropsTypes.number,
    type: PropsTypes.string
};
